import { _ as _slicedToArray } from '../../unsorted/slicedToArray.js';
import { useContext, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useBrowserEffect } from '../../hooks/useBrowserEffect.js';
import { B as BiomeShadowRootContext } from '../../providers/shadowRootContext/shadowRootContext.js';

function ClientOnlyPortal(_ref) {
  var children = _ref.children,
    selector = _ref.selector;
  var shadowRoot = useContext(BiomeShadowRootContext);
  var mountPointDomRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    portalMounted = _useState2[0],
    setPortalMounted = _useState2[1];
  useBrowserEffect(function () {
    // @TODO: wonder if we can modify this to try multiple times to
    // querySelector before giving up (e.g. if the element is not there yet)
    mountPointDomRef.current = shadowRoot ? shadowRoot.querySelector(selector) : document.querySelector(selector);
    if (mountPointDomRef.current) setPortalMounted(true);
    return function () {
      return setPortalMounted(false);
    };
  }, [selector]);
  return portalMounted && mountPointDomRef.current ? /*#__PURE__*/createPortal(children, mountPointDomRef.current) : null;
}

export { ClientOnlyPortal as C };
//# sourceMappingURL=ClientOnlyPortal.js.map
